import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../components";
import { TitleWrapper } from "../../../components/Charts/LineChart/styled";

export const LineChartContainer = styled(WrapperContainer)`
  ${TitleWrapper} {
    ${Paragraph2} {
      display: none;
    }

    ${Paragraph2}:first-of-type {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: #716e77;

      display: unset;
    }
  }
`;
